module.exports = __webpack_public_path__ + "img/calendar.f6c2e433.svg";